import {
  Alert,
  AlertTitle,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  IconBuildingBank,
  IconChevronRight,
  IconCoinRupee,
} from "@tabler/icons";
import { TailSpin } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import DashboardCard from "../../../components/shared/DashboardCard";

const TotalEarnings = ({ wallet, user }) => {
  const navigate = useNavigate();
  // chart color

  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  // const secondary = theme.palette.secondary.main;
  // const secondarylight = '#f5fcff';
  // const errorlight = '#fdede8';
  // const lgUp = useMediaQuery((theme)=>theme.breakpoints.up('lg'))
  // console.log(wallet)
  // const optionscolumnchart = {
  //   chart: {
  //     type: 'area',
  //     fontFamily: "'Plus Jakarta Sans', sans-serif;",
  //     foreColor: '#adb0bb',
  //     toolbar: {
  //       show: false,
  //     },
  //     height: 60,
  //     sparkline: {
  //       enabled: true,
  //     },
  //     group: 'sparklines',
  //   },
  //   stroke: {
  //     curve: 'smooth',
  //     width: 2,
  //   },
  //   fill: {
  //     colors: [secondarylight],
  //     type: 'solid',
  //     opacity: 0.05,
  //   },
  //   markers: {
  //     size: 0,
  //   },
  //   tooltip: {
  //     theme: theme.palette.mode === 'dark' ? 'dark' : 'light',
  //   },
  // };
  // const seriescolumnchart = [
  //   {
  //     name: '',
  //     color: secondary,
  //     data: [25, 66, 20, 40, 12, 58, 20],
  //   },
  // ];

  return (
    <DashboardCard
      title={""}
      footer={
        user && user?.bankAccount ? (
          <Alert
            variant="outlined"
            icon={<></>}
            sx={{
              display: { xs: "none", lg: "flex" },
              opacity: 1,
              bgcolor: "transparent",
              border: "none",
              color: "#E65100",
              minHeight: "80px",
              paddingBottom: "1rem",
            }}
          >
            <AlertTitle></AlertTitle>
          </Alert>
        ) : (
          <Alert
            variant="outlined"
            icon={<IconBuildingBank color="black" />}
            sx={{
              opacity: 1,
              bgcolor: "#F5F5F5",
              minHeight: "6vw",
              color: "#E65100",
            }}
          >
            <AlertTitle>Alert!</AlertTitle>
            Please Add your <Link to="/profile">Bank Account</Link> Details in
            order to Receive payments
          </Alert>
        )
      }
    >
      <Grid
        container
        xs={12}
        spacing={2}
        sx={{
          mb: { md: 2, xs: 2, lg: 0 },
          height: { xs: "65px", md: "100px" },
          position: "relative",
        }}
      >
        <Grid
          item
          xs={2}
          sx={{ minWidth: lgDown ? "35px" : "75px", paddingTop: 0, mt: -4 }}
        >
          <IconCoinRupee
            width={{ lg: 64, md: 35, sm: 42 }}
            height={{ lg: 64, md: 35, sm: 42 }}
            style={{ color: "black", minWidth: 35, marginRight: 1 }}
          />
        </Grid>
        <Grid container xs={8} spacing={1} sx={{ pl: { xs: 2, lg: 1 }, pb: 1 }}>
          <Grid item xs={12}>
            <Typography
              variant={lgDown ? "p" : "h4"}
              mt={lgDown ? 0 : ""}
              sx={{
                fontSize: lgDown ? "14px" : "1rem",
                whiteSpace: "pre",
                ml: 1,
              }}
            >
              Total Earnings
            </Typography>
          </Grid>
          <Grid item xs={12} justifyContent={"center"} spacing={3}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              fontWeight="700"
              ml={1}
            >
              <Typography
                variant={lgDown ? "h5" : "h4"}
                style={{ marginRight: "5px" }}
              >
                Rs.
              </Typography>
              <Typography variant={lgDown ? "h5" : "h4"}>
                {wallet?.totalEarned || wallet?.totalEarned == 0 ? (
                  wallet?.totalEarned.toFixed(2) || "0"
                ) : (
                  <TailSpin height={25} width={75} style={{ margin: "auto" }} />
                )}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
        {lgDown && window.location.pathname === "/dashboard" ? (
          <IconChevronRight
            width={{ lg: 64, md: 32, sm: 12 }}
            height={{ lg: 64, md: 32, sm: 12 }}
            style={{
              color: "black",
              position: "absolute",
              width: 32,
              translate: "40vw -5px",
            }}
            onClick={() => {
              navigate("/dashboard/transactions");
            }}
          />
        ) : null}
      </Grid>
      <ToastContainer />
    </DashboardCard>
  );
};

export default TotalEarnings;
